import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class DateService {
    public getProxDate(date: Date, hours: number) {
        const newDate = new Date(date);
        newDate.setHours(date.getHours() + hours); // Add one day
        return newDate
    }

    public getLocalIsosString(date: Date) {
        // Format the date in local time with ISO format including seconds but not milliseconds
        const pad = (num: number, size = 2) => String(num).padStart(size, '0');
        
        return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
    }
}
